import React, { useState } from 'react';
import { useUsersList } from '@dopomogai/agent-kit';
import { Card, Spinner, Alert, Button, Icon } from '@dopomogai/ui';
import { UserListItem } from './UserListItem';
import { UserFilterBar } from './UserFilterBar'; // <-- Import the new component

export const UserList: React.FC = () => {
  // State to hold the current filter values
  const [filters, setFilters] = useState({
    searchQuery: '',
    role: '',
  });

  // Pass the stateful filters object to the hook
  const { users, isLoading, error, mutate } = useUsersList(filters);

  return (
    <Card 
        title="All Users"
        // The noPadding prop is useful here to make the filter bar and list flush with the card edges
        noPadding 
    >
        {/* Render the new filter bar and pass it the state setter */}
        <UserFilterBar onFilterChange={setFilters} />

        <div className="p-3"> {/* Add padding back for the header and list content */}
            <div className="font-bold grid grid-cols-12 gap-4 py-2 bg-white text-sm text-slate-600 uppercase">
                <div className="col-span-4">User</div>
                <div className="col-span-2">Role</div>
                <div className="col-span-2">Balance</div>
                <div className="col-span-4 text-right">
                    <Button 
                        text="Refresh" 
                        variant="secondary" 
                        size="sm" 
                        icon={<Icon name="RefreshCw"/>} 
                        onClick={() => mutate()}
                        disabled={isLoading}
                    />
                </div>
            </div>
            {isLoading ? (
                <div className="flex justify-center items-center p-16">
                    <Spinner text="Loading users..." />
                </div>
            ) : error ? (
                <Alert type="error" title="Failed to load users" message={error.message} />
            ) : (
                <div>
                    {users && users.length === 0 ? (
                        <p className="text-center text-slate-500 p-8">No users found matching your filters.</p>
                    ) : (
                        users?.map(user => <UserListItem key={user.id} user={user} onActionSuccess={mutate} />)
                    )}
                </div>
            )}
        </div>
    </Card>
  );
};